import React from "react";
import { useLanguage } from "../LanguageContext";

const Resources: React.FC = () => {
    const { t } = useLanguage();
    const r = t.resources;
    return (
        <section className="resources" id="resources">
            <div className="section-number">04</div>
            <div className="container">
                <span className="section-eyebrow">{r.eyebrow}</span>
                <h2 className="section-title">{r.title}</h2>

                <div className="resources-list">
                    {r.items.map(item => (
                        <div className="resource-item" key={item.num}>
                            <div className="resource-num">{item.num}</div>
                            <div className="resource-content">
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                            <div className="resource-arrow">→</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Resources;
